import React, { useRef } from "react";
import HTMLFlipBook from "react-pageflip";

function Book() {
  const ref = useRef();

  return (
    <HTMLFlipBook
      width={420}
      height={600}
      minWidth={350}
      maxWidth={420}
      minHeight={500}
      maxHeight={600}
      size="fixed"
      showCover={true}
      usePortrait={false}
      ref={ref}
      drawShadow={true}
      maxShadowOpacity={0.5}
      flippingTime={900}
    >
      <div className="page cover-front">
        <img
          src="IKIGAI-Gujarati-front.jpg"
          alt="cover-front-image"
          className="cover-img"
        />
      </div>
      <div className="page inner-page orange">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page orange">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <div className="text-center cover-title">
            <h1>ઇકિગાઇ</h1>
            <p className="cover-subtitle">(生き甲斐)</p>
          </div>
          <div className="text-center">
            <h2>લેખકો</h2>
            <p>હેક્ટર ગાર્ષિયા (Héctor García)</p>
            <p>ફ્રાન્સિસ મિરાલેસ (Francis Miralles)</p>
          </div>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <h1>ચેપ્ટર</h1>
          <ul className="index-list">
            <li>૭ ઇકીગાઇ આહાર</li>
            <li>૯ સ્થિતિસ્થાપકતા અને વાબી-સાબી</li>
          </ul>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content"></div>
      </div>
      <div className="page">
        <div className="page-content chapter-page">
          <h1 className="chapter-number">૭</h1>
          <h2 className="chapter-title">ઇકીગાઇ આહાર</h2>
          <p className="quote">દુનિયાના સૌથી દીર્ઘાયુ લોકોના ખાન-પાનની વાતો</p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <p>
            ઓકિનાવાના લોકો સૌથી વધુ ૧૦૦ વર્ષથી ઉપર જીવે છે. તેમનો આહાર એ જ તેમની
            લાંબી ઉંમરનું સૌથી મોટું કારણ છે.
          </p>
          <h2 className="blue-heading">મુખ્ય નિયમો</h2>
          <p>
            ૧. ૯૫-૯૮% છોડ-આધારિત ખોરાક – શાકભાજી, કંદ-મૂળ, સોયાબીન, ટોફુ, ઓછું
            ચોખા <br />
            ૨. ખૂબ ઓછું માંસાલો, ખૂબ ઓછું તેલ <br />
            ૩. હળદર, આદુ અને મોગ્રા ચા રોજ પીવી <br />
            ૪. હારા હાચી બુ – પેટ ૮૦% જ ભરવું (જમતી વખતે ૮૦% થાય ત્યારે ઊઠી
            જવું) <br />
            ૫. દરરોજ ૫ થી ૭ લીલા શાકભાજી ખાવા <br />
            ૬.ચોખાની જગ્યાએ શક્કરિયા (sweet potato) વધુ ખાવું <br />
            ૭. દહીં કે દૂધ નહીં, પણ સોયા પ્રોડક્ટ્સ <br />
            ૮. મીઠું ખૂબ ઓછું (દુનિયાની સરેરાશના ૫૦% કરતાં પણ ઓછું)
          </p>
          <p>વધુ જીવવા માટે ઓછું જમવું.</p>
        </div>
      </div>
      <div className="page">
        <div className="page-content chapter-page">
          <h1 className="chapter-number">૯</h1>
          <h2 className="chapter-title">સ્થિતિસ્થાપકતા અને વાબી-સાબી</h2>
          <p className="quote">
            તણાવ અને ચિંતાથી વૃદ્ધત્વ નોતરી લાવ્યા સિવાય કઈ રીતે જીવનના પડકારોનો
            સામનો કરવો
          </p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <h2>વાબી-સાબી શું છે?</h2>
          <p className="text-block">
            - અપૂર્ણતામાં સુંદરતા જોવી
            <br />
            - જૂની વસ્તુઓ, તૂટેલી વસ્તુઓ, કરચલીઓ, ડાઘ – આ બધામાં સૌંદર્ય છે
            <br />- પર્ફેક્શનની પાછળ ના દોડવું → એનાથી તણાવ ઓછો થાય છે
          </p>
          <p>
            કંઈ પણ કાયમ નથી, કંઈ પણ પૂર્ણ નથી, કંઈ પણ પર્ફેક્ટ નથી – અને એ જ
            સુંદર છે.
          </p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <h2>સ્થિતિસ્થાપકતા (Resilience) અને એન્ટી-ફ્રેજાઇલ</h2>
          <p className="text-block">
            - સામાન્ય લોકો તણાવમાં તૂટી જાય છે
            <br />
            - સ્થિતિસ્થાપક લોકો તણાવમાં પાછા નોર્મલ થઈ જાય છે
            <br />- પણ ઓકિનાવાના લોકો એન્ટી-ફ્રેજાઇલ છે – તણાવ આવે તો એનાથી પણ
            વધુ મજબૂત બને છે!
          </p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <h2>સ્થિતિસ્થાપકતા, કેવી રીતે? (૭ આદતો)</h2>
          <p className="text-block">
            ૧. દરરોજ થોડું શારીરિક કષ્ટ કરો (ચાલવું, બાગકામ)
            <br />
            ૨. દરરોજ થોડી બુદ્ધિની કસરત (વાંચવું, નવું શીખવું)
            <br />
            ૩. હંમેશા નાનું-નાનું જોખમ લો (નવી વાત કરો, નવું કામ શરૂ કરો)
            <br />
            ૪. નિષ્ફળતાને મિત્ર બનાવો – જાપાનીઓ કહે “સાત વાર પડો, આઠ વાર ઊભા
            થાઓ”
            <br />
            ૫. દરરોજ કૃતજ્ઞતા લખો (૩-૫ વાતો)
            <br />
            ૬. પ્રકૃતિ સાથે સમય વિતાવો
            <br />
            ૭. ધ્યાન કે પ્રાર્થના ૫-૧૦ મિનિટ રોજ
          </p>
          <p>તણાવ નથી મારતો, તણાવની સામે લડવાનું ભૂલી જવું મારે છે.</p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <p className="text-center">
            હે પ્રભુ, <br />
            અમને જેને બદલી ન શકીએ <br />
            તેને નિર્મળતાથી સ્વીકારવાની શક્તિ આપ. <br />
            જેને બદલી શકીએ, <br />
            તેને બદલવાની હિંમત આપ. <br />
            અને આ બે વચ્ચેનો તફાવત <br />
            સમજવાની બુદ્ધિ આપ.
          </p>
          <p>
            બૌદ્ધ ધર્મ સિદ્ધાર્થ ગૌતમ (બુદ્ધ) — સમદષ્ટિવાદ <br /> લાલસા, ઇચ્છાઓ
            અને કુહાનાં ભોગવટાને નિયંત્રણમાં રાખવું. <br />
            લોકોની ઇચ્છાઓ ક્યારેય સંપૂર્ણ સંતોષ પામતી નથી. <br /> વર્તમાનનું જ
            અસ્તિત્વ છે, અને તેના પર જ આપણું નિયંત્રણ છે.
          </p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content">
          <p>
            <strong>ઇચિ-ગો ઇચિ-ઇ</strong>: આ ક્ષણ માત્ર અત્યારે જ છે અને ફરી
            ક્યારેય આવવાની નથી.
          </p>
          <p>
            Antifragile (એન્ટિફ્રેજાઈલ) = મક્કમતા
            <br />
            લોકોના હૃદયમાં રહેલી આ શક્તિ—ઘાવ સહન કર્યા પછી વધુ મજબૂત બની રહેવાની
            ક્ષમતા—માટે “મક્કમતા” એવો શબ્દ વપરાય છે. <br />
            દૃઢતા, અખંડતા, આત્મબળ, સહનશક્તિ બાદની મજબૂતી
          </p>
          <p>સુખ હંમેશા તમારા હૃદય દ્વારા જ પ્રાપ્ત થાય છે.</p>
          <p>આગળ વધતા રહો, માર્ગ બદલ્યા વિના</p>
        </div>
      </div>
      <div className="page inner-page">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page orange">
        <div className="page-content"></div>
      </div>
      <div className="page inner-page orange">
        <div className="page-content"></div>
      </div>
      <div className="page cover-back">
        <img
          src="IKIGAI-Gujarati-back.jpg"
          className="cover-img"
          alt="cover-back-image"
        />
      </div>
    </HTMLFlipBook>
  );
}

export default Book;
